module.exports = __webpack_public_path__ + "static/media/YF77_5.2c394717.JPG";